import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  standalone: false,
  templateUrl: './alarm-cdo-severity.cell.component.html',
  styleUrls: ['./alarm-cdo-severity.cell.component.scss']
})
export class AlarmCdoSeverityCellComponent implements ICellRendererAngularComp {

  cdoSeverity: any;

  constructor() {}

  agInit(params: any): void {
    this.cdoSeverity = params.value?.toUpperCase();
  }

  refresh(): boolean {
    return false;
  }
}